import { Box } from '@material-ui/core';
import { PaymentPlan, PaymentPlanLineStatus } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { usePaymentPlan } from '@/components/modules/PaymentPlan/components/PaymentPlanTableSection/components/PaymentPlanTable/components/PaymentPlanLineActionsDialog/hooks/usePaymentPlan';
import { PaymentPlanTable } from '@/components/modules/PaymentPlan/components/PaymentPlanTableSection/components/PaymentPlanTable/PaymentPlanTable';
import { PaymentPlanAction } from '@/components/modules/PaymentPlan/types/PaymentPlanAction';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { PendingDataType } from '@/config/types';

interface PaymentPlanTableSectionProps {
  paymentPlan: PaymentPlan;
  editModeAllowed?: boolean;
}

export const PaymentPlanTableSection = ({ paymentPlan, editModeAllowed = false }: PaymentPlanTableSectionProps) => {
  const { opened, setOpened, toggleDialog } = useDialog();
  const { cancelPaymentPlanById } = usePaymentPlan(paymentPlan);

  const [action, setAction] = useState<undefined | PaymentPlanAction>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const paymentPlanActions: ActionsOption[] = [
    {
      display: <Text tId={'CANCEL_PAYMENT_PLAN'} />,
      onClick: () => {
        setOpened(true);
        setAction(PaymentPlanAction.CANCEL_PAYMENT_PLAN);
      },
      iconName: 'cancel',
      disabled: paymentPlan.lines.every((line) => line.status === PaymentPlanLineStatus.CANCELLED),
    },
  ];

  const onCancelPaymentPlan = async () => {
    setLoading(true);
    try {
      await cancelPaymentPlanById();
      setAction(undefined);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
    toggleDialog();
  };

  return (
    <>
      <SubSectionWrapper
        title={'PAYMENT_PLAN_TABLE'}
        specificActionsOptionsArray={editModeAllowed ? paymentPlanActions : undefined}
      >
        {paymentPlan ? (
          <Box mt={2}>
            <PaymentPlanTable paymentPlan={paymentPlan} editModeAllowed={editModeAllowed} />
          </Box>
        ) : (
          <PendingDataWarning type={PendingDataType.DEFAULT} />
        )}
      </SubSectionWrapper>
      {opened && action === PaymentPlanAction.CANCEL_PAYMENT_PLAN && (
        <ActionDialog
          Title={<Text tId="CANCEL_PAYMENT_PLAN" />}
          Description={<Text tId="CANCEL_PAYMENT_PLAN_TEXT" />}
          MainButton={<Text tId="CANCEL_PAYMENT_PLAN" />}
          disabled={loading}
          onSubmit={onCancelPaymentPlan}
          opened={opened}
          setOpened={setOpened}
          handleClose={toggleDialog}
        />
      )}
    </>
  );
};
